var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _circle, _rect11, _rect12, _rect13, _rect14, _path3, _path4, _circle2, _rect15, _rect16, _rect17, _rect18, _path5, _path6, _ellipse, _circle3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgActivityDark = function SvgActivityDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#1D192D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 116,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 127,
    height: 28,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.75,
    y: 41.75,
    width: 125.5,
    height: 26.5,
    rx: 9.25,
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 53,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 53,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 51A9.25 9.25 0 0 1 46 41.75h17.25v26.5H46A9.25 9.25 0 0 1 36.75 59v-8Z",
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.176 58.62c1.196 1.281.285 3.372-1.467 3.366l-8.25-.024c-1.752-.005-2.651-2.101-1.447-3.374l4.139-4.376a2 2 0 0 1 2.914.01l4.11 4.399Z",
    fill: "#56516A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.333,
    cy: 50.333,
    r: 2.333,
    fill: "#56516A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 95,
    width: 127,
    height: 28,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.75,
    y: 87.75,
    width: 125.5,
    height: 26.5,
    rx: 9.25,
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 99,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 99,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 97A9.25 9.25 0 0 1 46 87.75h17.25v26.5H46a9.25 9.25 0 0 1-9.25-9.25v-8Z",
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.176 104.621c1.196 1.28.285 3.37-1.467 3.365l-8.25-.024c-1.752-.005-2.651-2.101-1.447-3.374l4.139-4.376a2 2 0 0 1 2.914.009l4.11 4.4Z",
    fill: "#56516A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.333,
    cy: 96.333,
    r: 2.333,
    fill: "#56516A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 6.606,
    y: 70.222,
    width: 165,
    height: 35.778,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 60.75,
    width: 163.5,
    height: 34.278,
    rx: 9.25,
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 61.173,
    y: 75.333,
    width: 51.968,
    height: 5.111,
    rx: 2.556,
    fill: "#322E43"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 150.819,
    y: 75.333,
    width: 15.591,
    height: 5.111,
    rx: 2.556,
    fill: "#322E43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 70A9.25 9.25 0 0 1 27 60.75h25.628v34.278H27a9.25 9.25 0 0 1-9.25-9.25V70Z",
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.093 83.442c1.212 1.276.304 3.383-1.456 3.378l-13.379-.04c-1.76-.004-2.656-2.117-1.436-3.386l6.712-6.979a2 2 0 0 1 2.892.01l6.667 7.017Z",
    fill: "#56516A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.126,
    cy: 71.926,
    rx: 3.031,
    ry: 2.981,
    fill: "#56516A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 80,
    fill: "url(#activity-dark_svg__a)",
    fillOpacity: 0.04
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "activity-dark_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.552 80.552) scale(79.4483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF",
    stopOpacity: 0
  })))));
};

export { SvgActivityDark as ReactComponent };
export default "data:image/svg+xml;base64,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";